import React, { useState } from "react";
import DatePicker, { DateObject} from "react-multi-date-picker";

const DateSearch = ({onDateChange, initDates = [
    new DateObject().setDay(5),
    new DateObject().setDay(14).add(1, "month"),
]}) => {
  const [dates, setDates] = useState(initDates);
  onDateChange(dates);

  return (
    <div className="text-15 text-light-1 ls-2 lh-16 custom_dual_datepicker">
      <DatePicker
        inputClass="custom_input-picker"
        containerClassName="custom_container-picker"
        value={dates}
        onChange={(date) => {
          setDates(date);
          onDateChange(date);}
        }
        numberOfMonths={2}
        offsetY={10}
        range
        rangeHover
        format="DD MMM"
        months={[
            ["Styczeń", "sty"],
            ["Luty", "lut"],
            ["Marzec", "mar"],
            ["Kwiecień", "kwi"],
            ["Maj", "maj"],
            ["Czerwiec", "cze"],
            ["Lipiec", "lip"],
            ["Sierpień", "sie"],
            ["Wrzesień", "wrz"],
            ["Październik", "paź"],
           ["Listopad", "lis"],
            ["Grudzień", "gru"],
        ]}
        weekDays={[
            "Pn",
            "Wt",
            "Śr",
            "Cz",
            "Pt",
            "So",
            "Nd"
        ]}
      />
    </div>
  );
};

export default DateSearch;
